<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Y2DqGq/tc-custom/9781680573237.jpg?1705317486212" alt="This image is the cover for the book Deprivers"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Deprivers
      </h1>
      <p class="bookDescription body article font2">
        <p><b>In this science fiction thriller by an <i>LA Times</i> bestseller, an assassin with the power to temporarily paralyze others helps with a hostage rescue.</b></p><p> Robert Luxley has a biological problem he does not understand and cannot control: one touch from his bare skin and you’re paralyzed for fifteen minutes. </p><p> Lonely and isolated, he’s turned his “special trick” into a lucrative career as a hired killer. He thinks he’s one of a kind—until one day he’s confronted by a young girl named Cassandra, who tells him he’s not alone. </p><p> She has it too, and the two of them are not the only ones. Carriers can render anyone they touch blind, deaf, or otherwise senseless, in seconds. </p><p> Fearing discovery, Luxley follows Cassandra through a dark underground network of “Deprivers” in a desperate hunt for her missing brother Nicholas, taken hostage by a radical group of carriers with a terrifying agenda. </p><p> Luxley doesn’t know who to trust, or who is safe to touch, but he needs to learn Cassandra’s secrets fast. </p><p><b>Praise for <i>Deprivers</i></b><b><i> </i></b></p><p><b>“A book that gets under your skin and on your nerves. The science is impressive; the fiction is haunting. It has a lot on its mind; and it will touch you.” —Mark Frost, co-creator of <i>Twin Peaks</i> </b></p><p><b>“<i>Deprivers</i> is the ultimate paranoia thriller—emphasis on the word thriller. Fans of everything from <i>The Hot Zone</i> to <i>The X-Files</i> take note, THIS BOOK IS GOING TO BLOW YOU AWAY!” — Rockne S. O’Bannon, creator of <i>Alien Nation</i>, <i>Farscape</i>, <i>Defiance</i> and <i>Cult</i></b></p><p><b>“<i>Deprivers</i> will take you to a terrifying and disturbing tomorrow and make you feel like you live there.” —David Brin, scientist and science fiction author, winner of the Hugo, Nebula, Campbell and Locus Awards</b></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Steven-Elliot Altman
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      WordFire Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5ce4b35a